import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCoins = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill='currentColor'
      d='M8.715 3.451a1 1 0 1 0 1.414 1.414zm10.42 10.42a1 1 0 0 0 1.414 1.415zm-3.398.76A6.37 6.37 0 0 1 9.37 21v2a8.37 8.37 0 0 0 8.368-8.37zM9.37 21A6.37 6.37 0 0 1 3 14.63H1A8.37 8.37 0 0 0 9.369 23zM3 14.63a6.37 6.37 0 0 1 6.369-6.368v-2A8.37 8.37 0 0 0 1 14.63zm6.369-6.368a6.37 6.37 0 0 1 6.368 6.369h2A8.37 8.37 0 0 0 9.37 6.26zm.76-3.397a6.37 6.37 0 0 1 9.006 0l1.414-1.414a8.37 8.37 0 0 0-11.834 0zm9.006 0a6.37 6.37 0 0 1 0 9.006l1.414 1.415a8.37 8.37 0 0 0 0-11.835z'
    />
  </svg>
);
export default SvgCoins;
